import React from 'react';
import EnvProvider from './EnvProvider';
import WindowProvider from './WindowProvider';
import '@/utils/csrbuddy/csrbuddy';
import { CSRBuddyContextProvider } from './csrBuddyContextProvider';
interface ProviderProps {
  children: React.ReactNode;
  configVars: any;
}

const Providers = ({ children, configVars }: ProviderProps) => {
  return (
    <WindowProvider>
      <EnvProvider configVars={configVars}><CSRBuddyContextProvider>{children}</CSRBuddyContextProvider></EnvProvider>
    </WindowProvider>
  );
}; 

export default Providers;
